import './Team.css';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getTeamDisplayName } from '@utils/teamDisplayName';
import Flag from './Flag';

const Team = ({ code, teams, align }) => (
  <Fragment>
    {align === 'left' && <Flag code={code} />}
    <span className="team-name">{getTeamDisplayName(teams, code)}</span>
    {align === 'right' && <Flag code={code} />}
  </Fragment>
);

Team.displayName = 'Team';
Team.propTypes = {
  code: PropTypes.string.isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  teams: PropTypes.object
};
Team.defaultProps = {
  align: 'left'
};

export default Team;
